module.exports = __webpack_public_path__ + "img/icon_goumaili_cunru.c7fda7bb.png";